<div class="forbiddenlayout">
    <div fxLayout="row" fxFill fxLayoutAlign="space-between center">
        <div class="forbiddenlayout-container mat-elevation-z4" fxFlexOffset="15" fxFlex="70">
            <img alt="ROSE" src="assets/favicons/favicon-96x96.png">
            <h1>
                <app-icon name="fal-ban"></app-icon>
                {{'Operation not permitted'|i18n}}
            </h1>
            <h3 *ngIf="model|async; let m">
                {{m.reason}}
            </h3>
        </div>
    </div>
</div>
